import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IChatVariablesService = ( createDecorator('IChatVariablesService'));
export { IChatVariablesService };
